import React from "react";
import "./stepFour.scss";

// Imagens:
import ImgStepFour from "../../../../assets/homeImgs/stepFour.png";

import { useTranslation } from "react-i18next";

const StepFour = () => {
  const { t } = useTranslation()
  
  return (
    <div className="container-step-four">

      <div className="img-step-four">
        <img src={ImgStepFour} alt="imagem step um" />
      </div>
      <div className="texts-step-four">
        <h1>4. {t("home.step4.title")}</h1>
        <p>{t("home.step4.section_text")}</p>
        {/* <button id="btn-step-four">CONFIRA!</button> */}
      </div>
    </div>
  );
};
export default StepFour;
